document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 767) { // Mobile only
    const buyButton = document.querySelector('.payment-and-quantity');
    const productContainer = document.querySelector('.product-container');
    const productTitle = document.querySelector('.product-title');
    const productPrice = document.querySelector('.product-price .current-price');
    const productComparePrice = document.querySelector('.product-price .was-price');
    
    if (buyButton && productContainer) {
      // Guardar referências aos botões e input ORIGINAIS (antes de clonar)
      const originalPlusBtn = buyButton.querySelector('.qty-adjuster__up');
      const originalMinusBtn = buyButton.querySelector('.qty-adjuster__down');
      const originalQuantityInput = buyButton.querySelector('.qty-adjuster__value');
      
      // AGORA SIM: Clona o botão original
      const stickyButton = buyButton.cloneNode(true);
      stickyButton.classList.add('payment-and-quantity--sticky');
      
      // Remove IDs duplicados do clone para evitar conflitos
      const clonedInputs = stickyButton.querySelectorAll('[id]');
      clonedInputs.forEach(el => {
        el.removeAttribute('id');
      });
      
             // Adiciona swatches de cor se existirem primeiro
       // Pequeno delay para garantir que os swatches estejam carregados
       setTimeout(() => {
         addColorSwatchesToSticky(stickyButton);
       }, 100);
       
       // Adiciona a linha de título e preço após os swatches
       if (productTitle && productPrice) {
         const stickyProductInfo = document.createElement('div');
         stickyProductInfo.className = 'sticky-product-info';
         
         const stickyTitle = document.createElement('div');
         stickyTitle.className = 'sticky-product-title';
         stickyTitle.textContent = productTitle.textContent.trim();
         
         stickyProductInfo.appendChild(stickyTitle);
         
         // Container para os preços
         const stickyPriceContainer = document.createElement('div');
         stickyPriceContainer.className = 'sticky-price-container';
         
         // Adiciona compare price se existir
         if (productComparePrice) {
           const stickyComparePrice = document.createElement('div');
           stickyComparePrice.className = 'sticky-product-compare-price';
           stickyComparePrice.innerHTML = productComparePrice.innerHTML;
           stickyPriceContainer.appendChild(stickyComparePrice);
         }
         
         const stickyPrice = document.createElement('div');
         stickyPrice.className = 'sticky-product-price';
         stickyPrice.innerHTML = productPrice.innerHTML;
         stickyPriceContainer.appendChild(stickyPrice);
         
         stickyProductInfo.appendChild(stickyPriceContainer);
         
         // Insere a linha de informações após os swatches
         stickyButton.insertBefore(stickyProductInfo, stickyButton.firstChild);
       }
      
            // Cria um wrapper para quantidade e botão
      const quantityWrapper = stickyButton.querySelector('.quantity');
      const addButtonWrapper = stickyButton.querySelector('.payment-and-quantity__add');
      
      if (quantityWrapper && addButtonWrapper) {
        
        // Remove os elementos originais
        quantityWrapper.remove();
        addButtonWrapper.remove();
        
        // Cria o wrapper flexível
        const flexWrapper = document.createElement('div');
        flexWrapper.className = 'sticky-flex-wrapper';
        
        // Adiciona quantidade e botão ao wrapper
        flexWrapper.appendChild(quantityWrapper);
        flexWrapper.appendChild(addButtonWrapper);
        
        // Adiciona o wrapper ao botão sticky
        stickyButton.appendChild(flexWrapper);
         
        // Sincronização: fazer os botões do sticky clicarem nos originais
        const stickyPlusBtn = quantityWrapper.querySelector('.qty-adjuster__up');
        const stickyMinusBtn = quantityWrapper.querySelector('.qty-adjuster__down');
        const stickyQuantityInput = quantityWrapper.querySelector('.qty-adjuster__value');
        
        if (stickyPlusBtn && originalPlusBtn) {
          stickyPlusBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            originalPlusBtn.click();
          });
        }
        
        if (stickyMinusBtn && originalMinusBtn) {
          stickyMinusBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            originalMinusBtn.click();
          });
        }
        
        // Sincronizar valores: quando o original mudar, atualizar o sticky
        if (stickyQuantityInput && originalQuantityInput) {
          // Eventos nativos
          originalQuantityInput.addEventListener('change', function() {
            stickyQuantityInput.value = this.value;
          });
          
          originalQuantityInput.addEventListener('input', function() {
            stickyQuantityInput.value = this.value;
          });
          
          // Método 2: Eventos jQuery (porque o theme.js usa jQuery)
          $(originalQuantityInput).on('change input', function() {
            stickyQuantityInput.value = this.value;
            
            // Sincronizar estado disabled dos botões
            if (stickyPlusBtn && originalPlusBtn) {
              if (originalPlusBtn.disabled) {
                stickyPlusBtn.setAttribute('disabled', 'disabled');
              } else {
                stickyPlusBtn.removeAttribute('disabled');
              }
            }
            
            if (stickyMinusBtn && originalMinusBtn) {
              if (originalMinusBtn.disabled) {
                stickyMinusBtn.setAttribute('disabled', 'disabled');
              } else {
                stickyMinusBtn.removeAttribute('disabled');
              }
            }
          });
          
          // MutationObserver para mudanças diretas no atributo value
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                stickyQuantityInput.value = originalQuantityInput.value;
              }
            });
          });
          
          observer.observe(originalQuantityInput, {
            attributes: true,
            attributeFilter: ['value']
          });
          
          // MutationObserver para monitorar disabled nos botões
          if (stickyPlusBtn && originalPlusBtn) {
            const plusObserver = new MutationObserver(function() {
              if (originalPlusBtn.disabled) {
                stickyPlusBtn.setAttribute('disabled', 'disabled');
              } else {
                stickyPlusBtn.removeAttribute('disabled');
              }
            });
            plusObserver.observe(originalPlusBtn, { attributes: true, attributeFilter: ['disabled'] });
          }
          
          if (stickyMinusBtn && originalMinusBtn) {
            const minusObserver = new MutationObserver(function() {
              if (originalMinusBtn.disabled) {
                stickyMinusBtn.setAttribute('disabled', 'disabled');
              } else {
                stickyMinusBtn.removeAttribute('disabled');
              }
            });
            minusObserver.observe(originalMinusBtn, { attributes: true, attributeFilter: ['disabled'] });
          }
          
          // Polling a cada 100ms (fallback final para valor e disabled)
          setInterval(function() {
            if (stickyQuantityInput.value !== originalQuantityInput.value) {
              stickyQuantityInput.value = originalQuantityInput.value;
            }
            
            // Sincronizar disabled
            if (stickyPlusBtn && originalPlusBtn) {
              if (originalPlusBtn.disabled !== stickyPlusBtn.disabled) {
                if (originalPlusBtn.disabled) {
                  stickyPlusBtn.setAttribute('disabled', 'disabled');
                } else {
                  stickyPlusBtn.removeAttribute('disabled');
                }
              }
            }
            
            if (stickyMinusBtn && originalMinusBtn) {
              if (originalMinusBtn.disabled !== stickyMinusBtn.disabled) {
                if (originalMinusBtn.disabled) {
                  stickyMinusBtn.setAttribute('disabled', 'disabled');
                } else {
                  stickyMinusBtn.removeAttribute('disabled');
                }
              }
            }
          }, 100);
        }
        
        // Adiciona listener para o botão de adicionar
        const addButton = addButtonWrapper.querySelector('.btn');
        if (addButton) {
          addButton.addEventListener('click', function(e) {
            // Simular clique no botão original
            const originalAddButton = document.querySelector('.payment-and-quantity .btn');
            if (originalAddButton) {
              originalAddButton.click();
            }
          });
        }
       }
      
             document.body.appendChild(stickyButton);
       
       // Função para verificar se deve mostrar o botão sticky
      function checkStickyVisibility() {
        const buyButtonRect = buyButton.getBoundingClientRect();
        const isBuyButtonVisible = buyButtonRect.bottom > 0 && buyButtonRect.top < window.innerHeight;
        
        // Verificar se está próximo ao footer
        const footer = document.querySelector('footer, .page-footer, .footer');
        let isNearFooter = false;
        
        if (footer) {
          const footerRect = footer.getBoundingClientRect();
          const distanceToFooter = footerRect.top - window.innerHeight;
          isNearFooter = distanceToFooter < 100; // 100px antes do footer
        }
        
        if (!isBuyButtonVisible && !isNearFooter) {
          stickyButton.classList.add('show');
          productContainer.style.paddingBottom = '100px';
        } else {
          stickyButton.classList.remove('show');
          // Pequeno delay para garantir que a transição seja executada
          setTimeout(() => {
            productContainer.style.paddingBottom = '';
          }, 300);
        }
      }
      
      // Listener de scroll para verificar visibilidade
      window.addEventListener('scroll', checkStickyVisibility);
      
             // Verificação inicial
       checkStickyVisibility();
       
       // Adicionar listener para mudanças de variante
       document.addEventListener('variant:change', function(event) {
         syncSwatchSelection();
       });
       
       // Também escutar mudanças nos inputs radio
       document.addEventListener('change', function(event) {
         if (event.target.type === 'radio' && event.target.name && event.target.name.includes('option')) {
           setTimeout(syncSwatchSelection, 100);
         }
       });
     }
   }
   
   // Função para sincronizar seleção dos swatches
   function syncSwatchSelection() {
     const selectedRadio = document.querySelector('input[type="radio"]:checked');
     if (selectedRadio) {
       const selectedValue = selectedRadio.value;
       
       // Atualizar swatches originais
       document.querySelectorAll('.swatch').forEach(swatch => {
         const radio = swatch.querySelector('input[type="radio"]');
         if (radio && radio.value === selectedValue) {
           swatch.classList.add('selected');
         } else {
           swatch.classList.remove('selected');
         }
       });
       
       // Atualizar swatches sticky - usar data attribute para mapear
       document.querySelectorAll('.sticky-swatch').forEach((stickySwatch, index) => {
         // Encontrar o swatch original correspondente pelo índice
         const originalSwatches = document.querySelectorAll('.swatch');
         if (originalSwatches[index]) {
           const originalRadio = originalSwatches[index].querySelector('input[type="radio"]');
                       if (originalRadio && originalRadio.value === selectedValue) {
              stickySwatch.classList.add('selected');
              
              // Adicionar check visual se não existir
              if (!stickySwatch.querySelector('.swatch-check')) {
                const check = document.createElement('span');
                check.className = 'swatch-check visible';
                stickySwatch.appendChild(check);
              }
            } else {
              stickySwatch.classList.remove('selected');
              
              // Remover check visual
              const check = stickySwatch.querySelector('.swatch-check');
              if (check) {
                check.remove();
              }
            }
          }
        });
      }
   }
   
          // Função para adicionar swatches de cor ao botão sticky
    function addColorSwatchesToSticky(stickyButton) {
      // Buscar swatches de cor existentes na página - tentar diferentes seletores
      let colorSwatches = document.querySelectorAll('.swatch');
      
      if (colorSwatches.length === 0) {
        // Tentar outros seletores possíveis
        colorSwatches = document.querySelectorAll('.swatch-color, .swatch-image, .swatch-label');
      }
      
      // Tentar mais seletores se ainda não encontrou
      if (colorSwatches.length === 0) {
        colorSwatches = document.querySelectorAll('[data-value]');
      }
    
                   if (colorSwatches.length > 0) {
        // Criar container para os swatches
        const swatchesContainer = document.createElement('div');
        swatchesContainer.className = 'sticky-color-swatches';
        
        // Verificar se há swatches válidos antes de mostrar o título
        let hasValidSwatches = false;
        colorSwatches.forEach(swatch => {
          const radioInput = swatch.querySelector('input[type="radio"]');
          if (radioInput && radioInput.value) {
            hasValidSwatches = true;
          }
        });
        
        // Só adicionar título se houver swatches válidos
        if (hasValidSwatches) {
          const swatchesTitle = document.createElement('div');
          swatchesTitle.className = 'sticky-swatches-title';
          swatchesTitle.textContent = 'Escolha seu tom preferido';
          swatchesContainer.appendChild(swatchesTitle);
        }
        
        // Adicionar swatches
        const swatchesWrapper = document.createElement('div');
        swatchesWrapper.className = 'sticky-swatches-wrapper';
       
              colorSwatches.forEach(swatch => {
          // Pegar o valor do input radio dentro do swatch
          const radioInput = swatch.querySelector('input[type="radio"]');
          const colorValue = radioInput ? radioInput.value : '';
          const isSelected = swatch.classList.contains('selected');
         
                    if (colorValue) {
             // Criar swatch limpo em vez de clonar
             const stickySwatch = document.createElement('div');
             stickySwatch.className = 'sticky-swatch';
             stickySwatch.setAttribute('data-value', colorValue);
           
           // Verificar se é swatch de cor, imagem ou texto
           const swatchColor = swatch.querySelector('.swatch-color');
           const swatchImage = swatch.querySelector('.swatch-image img');
           const swatchLabel = swatch.querySelector('.swatch-label');
           
                       if (swatchColor) {
              // Swatch de cor
              const colorSpan = document.createElement('span');
              colorSpan.className = 'swatch-color';
              colorSpan.style.backgroundColor = swatchColor.style.backgroundColor || '#ccc';
              colorSpan.style.border = 'none';
              stickySwatch.appendChild(colorSpan);
            } else if (swatchImage) {
              // Swatch de imagem
              const img = document.createElement('img');
              img.src = swatchImage.src;
              img.alt = swatchImage.alt;
              img.style.border = 'none';
              stickySwatch.appendChild(img);
            } else if (swatchLabel) {
              // Swatch de texto
              const textSpan = document.createElement('span');
              textSpan.className = 'swatch-label';
              textSpan.textContent = swatchLabel.textContent;
              textSpan.style.border = 'none';
              stickySwatch.appendChild(textSpan);
            }
           
           // Adicionar check de seleção se estiver selecionado
           if (isSelected) {
             stickySwatch.classList.add('selected');
             const check = document.createElement('span');
             check.className = 'swatch-check visible';
             stickySwatch.appendChild(check);
           }
           
                                   // Adicionar evento de clique
             stickySwatch.addEventListener('click', function(e) {
               e.preventDefault();
               
               // Remover seleção de todos os swatches
               document.querySelectorAll('.sticky-swatch').forEach(s => s.classList.remove('selected'));
               document.querySelectorAll('.swatch').forEach(s => s.classList.remove('selected'));
               
               // Adicionar seleção ao swatch clicado
               this.classList.add('selected');
               
                              // Encontrar e selecionar o swatch original correspondente
                const originalSwatch = document.querySelector(`.swatch input[value="${colorValue}"]`).closest('.swatch');
                
                if (originalSwatch) {
                  originalSwatch.classList.add('selected');
                  
                  // Encontrar o input radio do swatch original
                  const originalRadio = originalSwatch.querySelector('input[type="radio"]');
                  if (originalRadio) {
                    // Marcar o input como checked
                    originalRadio.checked = true;
                    
                    // Disparar evento change para atualizar a variante
                    const changeEvent = new Event('change', { bubbles: true });
                    originalRadio.dispatchEvent(changeEvent);
                    
                    // Também disparar evento input
                    const inputEvent = new Event('input', { bubbles: true });
                    originalRadio.dispatchEvent(inputEvent);
                    
                    // Aguardar um pouco e então sincronizar a seleção visual
                    setTimeout(() => {
                      syncSwatchSelection();
                    }, 200);
                  }
                  
                  // Simular clique no swatch original para garantir
                  originalSwatch.click();
                }
             });
           
           swatchesWrapper.appendChild(stickySwatch);
         }
       });
      
                           swatchesContainer.appendChild(swatchesWrapper);
        
        // Inserir os swatches no topo do botão sticky
        stickyButton.insertBefore(swatchesContainer, stickyButton.firstChild);
     }
   }
 });
